<template>
    <div class="modal-card" style="width:360px">
        <header class="modal-card-head">
            <p class="modal-card-title">Produktdetaljer</p>
        </header>
        
        <section class="modal-card-body">
            <b-field label="BransjeId">
                <b-input :value="product.branchId" disabled></b-input>
            </b-field>

            <b-field label="Bransjenavn">
                <b-input :value="product.branchName" disabled></b-input>
            </b-field>

            <b-field label="Pakke ID">
                <b-input v-model="product.id" required :disabled="!isNewProduct"></b-input>
            </b-field>

            <b-field label="Opphav">
                <b-select placeholder="Velg instans" v-model="product.instanceId" :disabled="!isNewProduct" required>
                    <option
                        v-for="option in sets"
                        :value="option.id"
                        :key="option.id">
                        {{ option.name }}
                    </option>
                </b-select>
                <!-- <b-input v-model="product.instanceId" required :disabled="!isNewProduct"></b-input> -->
            </b-field>

            <b-field label="Navn">
                <b-input v-model="product.name" required></b-input>
            </b-field>

            <b-field label="Rapporttype">
                <b-select placeholder="Velg rapporttype" v-model="product.reportType" required>
                    <option
                        v-for="option in reportTypes"
                        :value="option.id"
                        :key="option.id">
                        {{ option.name }}
                    </option>
                </b-select>
            </b-field>

            <div class="field" v-if="errorMsg">
                <span class="is-danger">{{ errorMsg }}</span>
            </div>

        </section>

        <footer class="modal-card-foot">
            <button class="button" type="button" @click="$parent.close()">Avbryt</button>
            <button class="button is-primary" @click="commitChanges()">Ok</button>
        </footer>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    props: ['product', 'isNewProduct'],
    data () {
        return {
            errorMsg: undefined
        }
    },
    computed: {
        ...mapGetters('reporttypes', ['reportTypes']),
        ...mapGetters('reportsets', ['sets'])
    },
    methods: {
        ...mapActions('products', ['saveProduct']),
        async commitChanges () {
            try {
                await this.saveProduct(this.product)
                this.$parent.close()
            } catch (error) {
                this.errorMsg = error.message
            }
        }
    }
}
</script>
